module.exports = __webpack_public_path__ + "media/images/app/products/index/styles/bracelets/diamond-80e9b54ab20f62a087121276a39819c0.webp";